// @flow

import type {User, Role, Ability} from './types'

export const can = (user: User, ability: Ability) =>
  user.abilities.includes(ability)

export const is = (user: User, role: Role) => user.roles.includes(role)
